import React, { useState } from 'react'
import { useOrderStore } from 'src/hooks/order';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import System from 'src/helper/system';
import { __remove, __set } from 'src/store/axios_indicator';
import Helper from 'src/helper/Helper';
import { useSystem } from "src/hooks/system";

const OrderHistoryEmailPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { SetStatus, data } = props;
    const singleOrder = data.singleOrder
    const singleProduct = data.singleProduct
    const { avUserInfoData: { email, accountNumber, userName}} = System
    const [,{ get_quantity_format }] = useSystem();
    const subject = 'In regard to the PO# ' + (Helper.valueIsNotNull(singleOrder?.poNumber)?singleOrder.poNumber:'') + ' - ' + singleProduct.manufacturerPartNumber + ' - for ' + accountNumber+ ' - ' + userName

    const initialState = {
        CC: '',
        message: ''
    }
    const [formData, SetFormData] = useState(initialState);
    const [validationError, setValidationError] = useState({ CCError: '', messageError: ''})
    const [{ }, { send_Order_Item_Email }, { }] = useOrderStore();

    const fromEmail = email
    const toEmail = (Helper.valueIsNotNull(singleOrder?.smrEmail)) ? singleOrder.smrEmail : "OnlineSupportUS@Avnet.com"
    const emailRegex = Helper.getEmailPattern();

    const OnSend = async () => {
        let error = false
        if (formData.CC.trim() !== '' && !formData.CC.match(emailRegex)) {
            setValidationError(prevState => ({ ...prevState, CCError: "Invalid email. Special characters (-+.'_) must be followed by letters or numbers."}));
            error = true
        }
        if (formData.message.length > 255) {
            setValidationError(prevState => ({ ...prevState, messageError: 'Maximum 255 characters allowed'}));
            error = true
        }

        if (!error && singleOrder && singleProduct) {
            __set('ORDER_LINE_ITEM_EMAIL_API_CALL')
            let res = await send_Order_Item_Email({
                orderDate: singleOrder.orderDate ? Helper.convertToYYYYMMDD(singleOrder.orderDate) : '-',
                //orderDate: "2024-09-03",
                poNumber: singleOrder?.poNumber,
                webOrderNumber: singleOrder?.webOrderNumber,
                orderNumber: singleOrder?.orderNumber,
                manufacturer: singleProduct.manufacturerName,
                manufacturerPartNumber: singleProduct.manufacturerPartNumber,
                customerPartNumber: singleProduct.customerPartNumber,
                quantity: singleProduct.quantity,
                cc: formData.CC.replace(/,/g, ";"),
                subject: subject,
                message: formData.message
            });

            __remove('ORDER_LINE_ITEM_EMAIL_API_CALL')

            if (res) {
                System.popup('OrderDetailEmailItemStatusPopup', { isSubmitted: true })
            }
            else {
                System.popup('OrderDetailEmailItemStatusPopup', { isSubmitted: false })
            }
        }
    }

    const onChange = (field, value) => {
        SetFormData({ ...formData, [field]: value });
    }

    return (
        <>
            <div className="avnet-modal modal-700">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" disabled={__check(['ORDER_LINE_ITEM_EMAIL_API_CALL']).status} className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="modal-title m-auto">{'Email - Line Item Message'}</h3>
                    </div>

                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className='bs5 row'>

                            <div className='col-6'>
                                <p className='mb-3 font-16 font-arial'><strong> ORDER INFORMATION</strong></p>
                                {singleOrder &&
                                    <div className='font-13 font-arial'>
                                        <div>
                                            <b>Order Date: </b> {singleOrder.orderDate ? Helper.convertOrderModuleDateFormat(singleOrder.orderDate) : '-'}
                                        </div>
                                        <div>
                                            <b>PO Number: </b> <span className='text-blue2'>{singleOrder?.poNumber?.trim() !== '' ? singleOrder?.poNumber : '-'}</span>
                                        </div>
                                        <div><b>Web Order Number : </b> <span className='text-blue2'>{singleOrder?.webOrderNumber}</span></div>
                                        <div><b>Order Number: </b> {singleOrder?.salesOrderNumber} </div>
                                    </div>
                                }
                            </div>
                            <div className='col-6'>
                                <p className='mb-3 font-16 font-arial'><strong>PART INFORMATION</strong></p>

                                {
                                    singleProduct &&
                                    <div className='font-13 font-arial'>
                                        <div><b>Manufacturer: </b> {singleProduct.manufacturerName ? singleProduct.manufacturerName : '-'}</div>
                                        <div><b>Manufacturer Part Number: </b> {singleProduct.manufacturerPartNumber ? singleProduct.manufacturerPartNumber : '-'}</div>
                                        <div><b>Customer Part Number: </b> {singleProduct.customerPartNumber ? singleProduct.customerPartNumber : '-'}</div>
                                        <div><b>Quantity: </b> {singleProduct.quantity ? get_quantity_format(Number(singleProduct.quantity)) : '-'}</div>
                                    </div>
                                }
                            </div>
                        </div>

                        <hr />

                        <div className='font-13 font-arial mb-3'>
                            <div><b>From: </b> {fromEmail}</div>
                            <div><b>To: </b> {toEmail}</div>
                        </div>

                        <div className="form-group">
                            <label htmlFor='CC'>CC</label>
                            <input type="text" name="CC"
                                className="form-control form-control-sm" placeholder=""
                                onChange={({ target: { value } }) => onChange("CC", value)} />
                            <p className="error">{validationError.CCError.trim().length > 0 && validationError.CCError}</p>
                        </div>
                        <div className="form-group mt-4">
                            <div className='bg-grey2 p-2'>
                                <label htmlFor="Subject"><b>Subject:</b> {subject}</label>
                            </div>
                        </div>
                        <div className="form-group mb-4">
                            <label htmlFor="Message"><b>{'Message'}</b></label>
                            {
                                <> <textarea name="name" rows="8" cols="60" className="form-control form-control-sm"
                                    placeholder="Type your message ..." maxLength={255}
                                    onChange={({ target: { value } }) => onChange("message", value)}></textarea>
                                    <p className='pull-right d-block mt-2 w-100 text-end text-black-stone'><i>Characters remaining {255 - formData.message.length > 0 ? 255 - formData.message.length : 0}/255</i></p>
                                    <p className="error">{validationError.messageError.trim().length > 0 && validationError.messageError} </p>
                                </>
                            }

                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center d-flex">
                        <div className="modal-footer-actions">
                            <button disabled={__check(['ORDER_LINE_ITEM_EMAIL_API_CALL']).status} type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={() => {
                                SetStatus(false)
                            }}>
                                Cancel
                            </button>
                            {<button disabled={__check(['ORDER_LINE_ITEM_EMAIL_API_CALL']).status} type="button" className="bs5 btn btn-primary btn-sm w145" data-dismiss="modal"
                                    onClick={(() => OnSend())}>
                                    {__check(['ORDER_LINE_ITEM_EMAIL_API_CALL']).status ? <i className="fa fa-spinner fa-spin" /> : 'SEND'}
                                </button>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderHistoryEmailPopup